export default __webpack_public_path__ + "static/media/partners-discount.9822478f.svg";